module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/umd-171.vue");


//////////////////
// WEBPACK FOOTER
// ./en/install/umd.md
// module id = 608
// module chunks = 393